import { useCallback, useEffect, useState } from "react";
import { fetchFtmValuationsHistory } from "../service";
import PaginationView from "./PaginationView";
import { formatTimestampInMap, formatMoney } from "../../../utils";

const History = ({ ftm_id, refreshKey, valuationId, setValuationId }) => {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);

    const getHistory = useCallback(async () => {
        if (!ftm_id) return;

        setLoading(true);
        try {
            const response = await fetchFtmValuationsHistory(ftm_id, page);

            if (response?.status === "Success") {
                setHistory(response.data ?? []);
                setTotalPages(response.totalPages ?? 0);
            } else {
                setHistory([]);
                setTotalPages(0);
            }
        } catch (err) {
            console.error("History fetch error:", err);
        } finally {
            setLoading(false);
        }
    }, [ftm_id, page]);

    useEffect(() => {
        getHistory();
    }, [getHistory, refreshKey]); // ✅ refresh trigger added

    const handlePageChange = useCallback((newPage) => {
        setPage((prev) => (prev === newPage ? prev : newPage));
    }, []);

    return (
        <div className="col-lg-12 col-12 mt-md-0 mt-4">
            <div className="card h-100 mb-4">
                <div className="card-header pb-0 px-3">
                    <div className="row">
                        <div className="col-md-6">
                            <h6 className="mb-0">Valuation History</h6>
                        </div>
                    </div>
                </div>

                <div className="card-body pt-4 p-3">

                    {/* ✅ Loading State */}
                    {loading ? (
                        <div className="text-center py-3" style={{ height: "276px", overflowY: "auto" }}>Loading...</div>
                    ) : history.length === 0 ? (
                        <div className="text-center py-3 text-muted" style={{ height: "276px", overflowY: "auto" }}>
                            No history found
                        </div>
                    ) : (
                        <ul
                            className="list-group"
                            style={{ height: "276px", overflowY: "auto" }}
                        >
                            {history.map((item) => (
                                <li
                                    key={item.ftm_valuation_id}
                                    className={`list-group-item border-0 d-flex justify-content-between mb-2 ${valuationId === item.ftm_valuation_id ? "list-selected-row" : ""}`}
                                    onClick={() => setValuationId(item.ftm_valuation_id)}
                                >
                                    {/* LEFT SIDE */}
                                    <div className="d-flex align-items-center">
                                        <div className="btn btn-icon-only btn-rounded btn-outline-success mb-0 me-3 p-3 btn-sm d-flex align-items-center justify-content-center">
                                            <i className="material-icons text-lg">money</i>
                                        </div>

                                        <div className="d-flex flex-column">
                                            <h6 className="mb-0 text-dark text-sm">
                                                {formatTimestampInMap(item.ftm_valuation_running_timestamp)} — Validation executed by {item.admin?.admin_full_name ?? "N/A"}. 
                                            </h6>
                                        </div>
                                    </div>

                                    {/* RIGHT SIDE (GROUPED) */}
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="text-success text-gradient text-sm font-weight-bold">
                                            {formatMoney(item.total_paid ?? 0)}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}

                    {/* ✅ Pagination only if needed */}
                    {!loading && (
                        <PaginationView
                            totalPages={totalPages}
                            page={page}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default History;